(function () {
  "use strict";

  var VEHICLE_DATA_URL_RAW = window.A2Z_TPMS_DATA_URL || "//a2ztiresupplies.com/cdn/shop/t/76/assets/mym.json?v=130203457238728061211772113065";
  var MODEL_YEAR_CAP = new Date().getFullYear() + 1;

  function toSameOriginAssetUrl(url) {
    var input = String(url || "").trim();
    if (!input) return input;

    try {
      var parsed = new URL(input, window.location.href);
      if (parsed.origin !== window.location.origin) {
        // Force same-origin to avoid CORS in preview/custom-domain contexts.
        return parsed.pathname + parsed.search + parsed.hash;
      }
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (e) {
      return input;
    }
  }

  var VEHICLE_DATA_URL = toSameOriginAssetUrl(VEHICLE_DATA_URL_RAW);

  function tpmsNow(fn) {
    if (typeof fn !== "function") return;
    if (window.queueMicrotask) return window.queueMicrotask(fn);
    Promise.resolve().then(fn);
  }

  function isMobileUA() {
    try {
      if (window.matchMedia) return window.matchMedia("(max-width: 749px)").matches;
    } catch (e) {}
    return false;
  }

  function safeEscape(s) {
    s = String(s);
    try {
      if (window.CSS && typeof window.CSS.escape === "function") return window.CSS.escape(s);
    } catch (e) {}
    return s.replace(/["\\]/g, "\\$&");
  }

  var VEHICLES = null;
  var VEHICLES_PROMISE = null;

  function loadVehicles() {
    if (VEHICLES) return Promise.resolve(VEHICLES);
    if (VEHICLES_PROMISE) return VEHICLES_PROMISE;

    VEHICLES_PROMISE = fetch(VEHICLE_DATA_URL, { credentials: "same-origin" })
      .then(function (r) {
        if (r && r.ok) return r.json();
        return Promise.reject(new Error("mym.json " + (r ? r.status : "unknown")));
      })
      .then(function (data) {
        VEHICLES = (data && data.vehicles && Array.isArray(data.vehicles)) ? data.vehicles : [];
        return VEHICLES;
      })
      .catch(function (e) {
        VEHICLES_PROMISE = null;
        try { console.error(e); } catch (_) {}
        throw e;
      });

    return VEHICLES_PROMISE;
  }

  function toYear(x) {
    var n = Number(x);
    return isFinite(n) ? n : NaN;
  }

  function effectiveStartYear(v) {
    var start = toYear(v && v.year_start);
    return isFinite(start) ? start : 1900;
  }

  function effectiveEndYear(v) {
    var end = toYear(v && v.year_end);
    if (!isFinite(end) || end === -1) return MODEL_YEAR_CAP;
    return Math.min(end, MODEL_YEAR_CAP);
  }

  function uniqSorted(arr) {
    var seen = {};
    var out = [];
    var i, s;
    for (i = 0; i < arr.length; i++) {
      if (arr[i] === null || arr[i] === undefined) continue;
      s = String(arr[i]).trim();
      if (!s) continue;
      if (!seen[s]) {
        seen[s] = 1;
        out.push(s);
      }
    }
    out.sort(function (a, b) { return String(a).localeCompare(String(b)); });
    return out;
  }

  function setSelectOptions(selectEl, placeholder, values) {
    if (!selectEl) return;
    selectEl.textContent = "";

    var opt0 = document.createElement("option");
    opt0.value = "";
    opt0.textContent = placeholder;
    selectEl.appendChild(opt0);

    for (var i = 0; i < values.length; i++) {
      selectEl.appendChild(new Option(String(values[i]), String(values[i])));
    }
  }

  function killBvAnchorsInside(root) {
    if (!root || root.__tpmsKillBvAnchors) return;
    root.__tpmsKillBvAnchors = true;

    root.addEventListener("click", function (e) {
      var a = e && e.target && e.target.closest ? e.target.closest("a") : null;
      if (!a) return;
      if (!root.contains(a)) return;

      var href = (a.getAttribute("href") || "").trim();
      if (href === "./" || href === "#" || href === "") {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function forceNativeSelect(selectEl) {
    if (!selectEl) return;

    var wrap = selectEl.parentElement;
    if (wrap) {
      var bv = wrap.querySelector(":scope > .bv_mainselect");
      if (bv) bv.remove();
    }

    selectEl.classList.remove("hidden");
    selectEl.classList.remove("select-init");
    selectEl.classList.remove("semantic-select-initialized");
    selectEl.removeAttribute("tabindex");

    selectEl.style.display = "";
    selectEl.style.visibility = "";
    selectEl.style.opacity = "";
    selectEl.removeAttribute("aria-hidden");
  }

  function findProductFormForRoot(root) {
    var uid = root.getAttribute("data-tpms-uid") || "";
    if (uid) {
      var selector = 'input[name="section-id"][value="' + safeEscape(uid) + '"]';
      var sectionInput = document.querySelector(selector);
      if (sectionInput) {
        var f = sectionInput.closest("form");
        if (f) return f;
      }
    }

    var f1 = root.closest("form");
    if (f1) return f1;

    var pf = root.closest("product-form");
    if (pf) {
      var f2 = pf.querySelector('form[action*="/cart/add"]');
      if (f2) return f2;
    }

    var f3 = document.querySelector('product-form form[action*="/cart/add"]');
    if (f3) return f3;

    return document.querySelector('form[action*="/cart/add"]') || null;
  }

  function ensureHiddenInForm(form, name, marker) {
    if (!form) return null;
    var el = form.querySelector('input[type="hidden"][' + marker + ']');
    if (!el) {
      el = document.createElement("input");
      el.type = "hidden";
      el.setAttribute(marker, "");
      form.appendChild(el);
    }
    el.name = name;
    return el;
  }

  function readTpmsStateFromRoot(root) {
    if (!root) return null;

    var makeSel = root.querySelector("[data-tpms-make-select]");
    var modelSel = root.querySelector("[data-tpms-model-select]");
    var yearSel = root.querySelector("[data-tpms-year-select]");
    var checkbox = root.querySelector("[data-tpms-preprogram]");

    if (!makeSel || !modelSel || !yearSel || !checkbox) return null;

    return {
      make: makeSel.value || "",
      model: modelSel.value || "",
      year: yearSel.value || "",
      checkbox: checkbox
    };
  }

  function findNearestTpmsRootFrom(el) {
    if (!el || !el.closest) return document.querySelector("[data-tpms-fitment]");
    return el.closest("[data-tpms-fitment]") || document.querySelector("[data-tpms-fitment]");
  }

  function isCartAddUrl(url) {
    return String(url || "").indexOf("/cart/add") !== -1;
  }

  function buildPairs(tpms) {
    if (!tpms) return null;

    var shouldWrite =
      tpms.checkbox &&
      tpms.checkbox.checked &&
      !tpms.checkbox.disabled &&
      tpms.make &&
      tpms.model &&
      tpms.year;

    if (!shouldWrite) return null;

    return [
      ["properties[Make]", tpms.make],
      ["properties[Model]", tpms.model],
      ["properties[Year]", tpms.year]
    ];
  }

  function injectPropsIntoForm(form, tpms) {
    if (!form) return;

    var hm = ensureHiddenInForm(form, "properties[Make]", "data-tpms-form-make");
    var hmo = ensureHiddenInForm(form, "properties[Model]", "data-tpms-form-model");
    var hy = ensureHiddenInForm(form, "properties[Year]", "data-tpms-form-year");

    var pairs = buildPairs(tpms);
    if (!pairs) {
      if (hm) hm.value = "";
      if (hmo) hmo.value = "";
      if (hy) hy.value = "";
      return;
    }

    if (hm) hm.value = pairs[0][1];
    if (hmo) hmo.value = pairs[1][1];
    if (hy) hy.value = pairs[2][1];
  }

  function injectIntoFormData(fd, pairs) {
    if (!fd || !pairs) return fd;
    try { fd.delete("properties[Make]"); } catch (e) {}
    try { fd.delete("properties[Model]"); } catch (e) {}
    try { fd.delete("properties[Year]"); } catch (e) {}
    fd.append("properties[Make]", pairs[0][1]);
    fd.append("properties[Model]", pairs[1][1]);
    fd.append("properties[Year]", pairs[2][1]);
    return fd;
  }

  function injectIntoUrlEncoded(bodyStr, pairs) {
    var usp = new URLSearchParams(String(bodyStr || ""));
    try { usp.delete("properties[Make]"); } catch (e) {}
    try { usp.delete("properties[Model]"); } catch (e) {}
    try { usp.delete("properties[Year]"); } catch (e) {}
    if (pairs) {
      usp.append("properties[Make]", pairs[0][1]);
      usp.append("properties[Model]", pairs[1][1]);
      usp.append("properties[Year]", pairs[2][1]);
    }
    return usp.toString();
  }

  function initTpms(root) {
    if (!root || root.__tpmsBound) return;
    root.__tpmsBound = true;
    if (root.classList) {
      root.classList.add("tpms-fitment", "tpms-fitment-tight");
    }

    var makeSelect = root.querySelector("[data-tpms-make-select]");
    var modelSelect = root.querySelector("[data-tpms-model-select]");
    var yearSelect = root.querySelector("[data-tpms-year-select]");
    var checkbox = root.querySelector("[data-tpms-preprogram]");
    var checkboxLabel = root.querySelector("[data-tpms-preprogram-label]");
    var resultWrap = root.querySelector("[data-tpms-result]");
    var resultIcon = root.querySelector("[data-tpms-result-icon]");
    var resultText = root.querySelector("[data-tpms-result-text]");

    if (!makeSelect || !modelSelect || !yearSelect || !checkbox) return;

    killBvAnchorsInside(root);
    if (!isMobileUA()) {
      forceNativeSelect(makeSelect);
      forceNativeSelect(modelSelect);
      forceNativeSelect(yearSelect);
    }

    var form = findProductFormForRoot(root);

    function setResult(status, year, make, model) {
      if (!resultWrap || !resultIcon || !resultText) return;

      if (status === "hide") {
        resultWrap.hidden = true;
        resultIcon.textContent = "";
        resultIcon.style.background = "";
        resultIcon.style.color = "";
        resultText.textContent = "";
        if (checkboxLabel) {
          checkboxLabel.innerHTML =
            'Buy Pre-Programmed to<br><strong style="font-weight:700;">"selected vehicle"</strong>';
        }
        return;
      }

      resultWrap.hidden = false;

      if (status === "yes") {
        resultIcon.textContent = "✓";
        resultIcon.style.background = "#16a34a";
        resultIcon.style.color = "#ffffff";
        resultText.textContent = "Compatible!";
      } else if (status === "no") {
        resultIcon.textContent = "✕";
        resultIcon.style.background = "#dc2626";
        resultIcon.style.color = "#ffffff";
        resultText.textContent = "Not Compatible!";
      } else {
        resultIcon.textContent = "!";
        resultIcon.style.background = "#6b7280";
        resultIcon.style.color = "#ffffff";
        resultText.textContent = "Provide Missing Information";
      }

      if (checkboxLabel) {
        if (year && make && model) {
          checkboxLabel.innerHTML =
            'Buy Pre-Programmed to<br><strong style="font-weight:700;">"' +
            String(year) + " " + String(make) + " " + String(model) +
            '"</strong>';
        } else {
          checkboxLabel.innerHTML =
            'Buy Pre-Programmed to<br><strong style="font-weight:700;">"selected vehicle"</strong>';
        }
      }
    }

    function selectionComplete() {
      return !!(makeSelect.value && modelSelect.value && yearSelect.value);
    }

    function lockCheckbox(disabled, checked) {
      checkbox.disabled = !!disabled;
      checkbox.checked = !!checked;
      injectPropsIntoForm(form, readTpmsStateFromRoot(root));
    }

    function resetModels() {
      modelSelect.disabled = true;
      yearSelect.disabled = true;
      setSelectOptions(modelSelect, "Select Model", []);
      setSelectOptions(yearSelect, "Select Year", []);
      modelSelect.value = "";
      yearSelect.value = "";
      lockCheckbox(true, false);
      setResult("hide");
    }

    function resetYears() {
      yearSelect.disabled = true;
      setSelectOptions(yearSelect, "Select Year", []);
      yearSelect.value = "";
      lockCheckbox(true, false);
      setResult("maybe", "", makeSelect.value || "", modelSelect.value || "");
    }

    function syncBeforeBuy() {
      if (checkbox.checked) {
        if (checkbox.disabled || !selectionComplete()) checkbox.checked = false;
      }
      injectPropsIntoForm(form, readTpmsStateFromRoot(root));
    }

    checkbox.addEventListener("change", function () {
      injectPropsIntoForm(form, readTpmsStateFromRoot(root));
    });

    if (form) {
      form.addEventListener("submit", function () { syncBeforeBuy(); }, true);
      form.addEventListener("click", function (e) {
        var t = e.target;
        if (!t || !t.closest) return;

        var btn = t.closest("button, input, a, shop-pay-wallet-button, shopify-accelerated-checkout");
        if (!btn) return;
        if (btn.closest && btn.closest(".tpms-fitment")) return;

        if (
          btn.matches("button[type='submit'], input[type='submit']") ||
          btn.classList.contains("overlay-buy_button") ||
          btn.getAttribute("name") === "add" ||
          (btn.closest && btn.closest(".shopify-payment-button")) ||
          (btn.matches && btn.matches("shop-pay-wallet-button")) ||
          btn.id === "more-payment-options-link"
        ) {
          syncBeforeBuy();
        }
      }, true);
    }

    loadVehicles()
      .then(function (rows) {
        var allRows = rows || [];

        var makes = uniqSorted(allRows.map(function (v) { return v && v.make; }));
        setSelectOptions(makeSelect, "Select Make", makes);
        makeSelect.disabled = false;

        resetModels();

        makeSelect.addEventListener("change", function () {
          var make = makeSelect.value;
          resetModels();
          if (!make) return;

          var modelsRaw = [];
          for (var i = 0; i < allRows.length; i++) {
            if (String(allRows[i] && allRows[i].make) === String(make)) modelsRaw.push(allRows[i].model);
          }

          var models = uniqSorted(modelsRaw);
          var idx = -1;
          for (var j = 0; j < models.length; j++) if (models[j] === "Model S") idx = j;
          if (idx > -1) {
            models.splice(idx, 1);
            models.unshift("Model S");
          }

          setSelectOptions(modelSelect, "Select Model", models);
          modelSelect.disabled = false;
          setResult("maybe", "", make, "");
        });

        modelSelect.addEventListener("change", function () {
          var make = makeSelect.value;
          var model = modelSelect.value;
          resetYears();
          if (!make || !model) return;

          var years = {};
          for (var i = 0; i < allRows.length; i++) {
            var v = allRows[i];
            if (String(v && v.make) === String(make) && String(v && v.model) === String(model)) {
              var start = effectiveStartYear(v);
              var end = effectiveEndYear(v);
              for (var y = start; y <= end; y++) years[String(y)] = 1;
            }
          }

          var yearList = Object.keys(years).sort(function (a, b) { return Number(a) - Number(b); });
          setSelectOptions(yearSelect, "Select Year", yearList);
          yearSelect.disabled = false;
          setResult("maybe", "", make, model);
        });

        yearSelect.addEventListener("change", function () {
          var make = makeSelect.value;
          var model = modelSelect.value;
          var yearNum = Number(yearSelect.value);

          if (!make || !model || !isFinite(yearNum)) {
            lockCheckbox(true, false);
            setResult("maybe", "", make, model);
            return;
          }

          var match = null;
          for (var i = 0; i < allRows.length; i++) {
            var v = allRows[i];
            if (String(v && v.make) !== String(make) || String(v && v.model) !== String(model)) continue;
            var start = effectiveStartYear(v);
            var end = effectiveEndYear(v);
            if (yearNum >= start && yearNum <= end) { match = v; break; }
          }

          if (!match) {
            lockCheckbox(true, false);
            setResult("maybe", yearSelect.value, make, model);
            return;
          }

          var ok = String(match && match.is_compatible).toLowerCase() === "yes";
          if (ok) {
            lockCheckbox(false, checkbox.checked);
            setResult("yes", yearSelect.value, make, model);
          } else {
            lockCheckbox(true, false);
            setResult("no", yearSelect.value, make, model);
          }

          syncBeforeBuy();
        });
      })
      .catch(function () {
        makeSelect.disabled = true;
        modelSelect.disabled = true;
        yearSelect.disabled = true;
        lockCheckbox(true, false);
        setResult("hide");
      });
  }

  function initAll() {
    var blocks = document.querySelectorAll("[data-tpms-fitment]");
    for (var i = 0; i < blocks.length; i++) initTpms(blocks[i]);
  }

  tpmsNow(initAll);

  var mo = new MutationObserver(function () { tpmsNow(initAll); });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  (function installUniversalCapture() {
    if (window.__tpmsUniversalCaptureInstalled) return;
    window.__tpmsUniversalCaptureInstalled = true;

    document.addEventListener("submit", function (e) {
      var form = e.target;
      if (!form || !form.action || !isCartAddUrl(form.action)) return;

      var root = findNearestTpmsRootFrom(form);
      var tpms = readTpmsStateFromRoot(root);
      injectPropsIntoForm(form, tpms);
    }, true);

    document.addEventListener("click", function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var btn = t.closest("button, input[type='submit'], a, shop-pay-wallet-button, shopify-accelerated-checkout");
      if (!btn) return;

      var form =
        (btn.closest && btn.closest('form[action*="/cart/add"]')) ||
        (btn.closest && btn.closest("product-form") && btn.closest("product-form").querySelector('form[action*="/cart/add"]')) ||
        (btn.closest && btn.closest("form")) ||
        document.querySelector('form[action*="/cart/add"]');

      if (!form || !form.action || !isCartAddUrl(form.action)) return;

      var root = findNearestTpmsRootFrom(btn);
      var tpms = readTpmsStateFromRoot(root);
      injectPropsIntoForm(form, tpms);
    }, true);

    var origFetch = window.fetch;
    if (typeof origFetch === "function") {
      window.fetch = function (input, init) {
        try {
          var req = (input && typeof Request !== "undefined" && input instanceof Request) ? input : null;
          var url = req ? req.url : String(input || "");
          var method = String((init && init.method) || (req && req.method) || "GET").toUpperCase();

          if (!isCartAddUrl(url) || method !== "POST") {
            return origFetch.apply(this, arguments);
          }

          var root = findNearestTpmsRootFrom(document.activeElement || document.body);
          var tpms = readTpmsStateFromRoot(root);
          var pairs = buildPairs(tpms);
          if (!pairs) return origFetch.apply(this, arguments);

          if (init && init.body && (typeof FormData !== "undefined") && (init.body instanceof FormData)) {
            injectIntoFormData(init.body, pairs);
            return origFetch.call(this, input, init);
          }

          if (init && typeof init.body === "string") {
            init.body = injectIntoUrlEncoded(init.body, pairs);
            return origFetch.call(this, input, init);
          }

          if (init && (typeof URLSearchParams !== "undefined") && (init.body instanceof URLSearchParams)) {
            try {
              init.body.delete("properties[Make]");
              init.body.delete("properties[Model]");
              init.body.delete("properties[Year]");
            } catch (e) {}
            init.body.append("properties[Make]", pairs[0][1]);
            init.body.append("properties[Model]", pairs[1][1]);
            init.body.append("properties[Year]", pairs[2][1]);
            return origFetch.call(this, input, init);
          }

          return origFetch.apply(this, arguments);
        } catch (e) {
          return origFetch.apply(this, arguments);
        }
      };
    }

    var XHR = window.XMLHttpRequest;
    if (XHR && XHR.prototype && !XHR.prototype.__tpmsPatched) {
      XHR.prototype.__tpmsPatched = true;

      var origOpen = XHR.prototype.open;
      var origSend = XHR.prototype.send;

      XHR.prototype.open = function (method, url) {
        try {
          this.__tpms_method = String(method || "GET").toUpperCase();
          this.__tpms_url = String(url || "");
        } catch (e) {}
        return origOpen.apply(this, arguments);
      };

      XHR.prototype.send = function (body) {
        try {
          if (this.__tpms_method === "POST" && isCartAddUrl(this.__tpms_url)) {
            var root = findNearestTpmsRootFrom(document.activeElement || document.body);
            var tpms = readTpmsStateFromRoot(root);
            var pairs = buildPairs(tpms);

            if (pairs) {
              if ((typeof FormData !== "undefined") && (body instanceof FormData)) {
                injectIntoFormData(body, pairs);
                return origSend.call(this, body);
              }
              if (typeof body === "string") {
                var body2 = injectIntoUrlEncoded(body, pairs);
                return origSend.call(this, body2);
              }
              if ((typeof URLSearchParams !== "undefined") && (body instanceof URLSearchParams)) {
                try {
                  body.delete("properties[Make]");
                  body.delete("properties[Model]");
                  body.delete("properties[Year]");
                } catch (e) {}
                body.append("properties[Make]", pairs[0][1]);
                body.append("properties[Model]", pairs[1][1]);
                body.append("properties[Year]", pairs[2][1]);
                return origSend.call(this, body);
              }
            }
          }
        } catch (e) {}
        return origSend.apply(this, arguments);
      };
    }
  })();
})();
